<template>
  <div class="content">
    <div class="bodycontent" v-loading="loading">
      <el-form
        :model="formData"
        ref="formData"
        label-width="180px"
        size="small"
      >
        <el-form-item label="等级名称">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        
        <el-form-item label="是否默认">
          <el-radio-group v-model="formData.is_default">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="会员等级">
          <el-table :data="levelSet" size="small" style="width:700px" ref="levelTable">
            <el-table-column type="expand" align="center">
              <template slot-scope="props">
                <el-form size="small" label-width="80px">
                  <el-form-item label="等级名称">{{props.row.name}}</el-form-item>
                  <el-form-item label="优惠时间">
                    <el-radio-group v-model="props.row.timeType">
                      <el-radio :label="0">长期有效</el-radio>
                      <el-radio :label="1">固定时间段</el-radio>
                      <el-radio :label="2">按周期重复</el-radio>
                    </el-radio-group>
                    <div v-if="timeType == 1">
                      <el-date-picker
                        v-model="props.row.dateValue"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        size="small"
                      >
                      </el-date-picker>
                    </div>
                    <div v-if="timeType == 2">
                      <el-radio-group v-model="props.row.periodType">
                        <el-radio label="0" class="dblock">
                          <span class="radio_name">每天</span>
                          <el-time-picker
                            v-model="props.row.dayTimeValue[0]"
                            :disabled="periodType != '0'"
                            class="time_picker_box"
                            format="HH:mm"
                            value-format="HH:mm"
                            arrow-control
                            size="small"
                            style="width:100px"
                          ></el-time-picker>
                          至
                          <el-time-picker
                            v-model="props.row.dayTimeValue[1]"
                            :disabled="periodType != '0'"
                            class="time_picker_box"
                            format="HH:mm"
                            value-format="HH:mm"
                            arrow-control
                            size="small"
                            style="width:100px"
                          ></el-time-picker>
                        </el-radio>
                        <el-radio label="1" class="dblock">
                          <span class="radio_name">每月</span>
                          <el-select
                            :disabled="periodType != '1'"
                            v-model="props.row.monthDayValue"
                            multiple
                            collapse-tags
                            placeholder="请选择"
                            size="small"
                            style="width:120px"
                          >
                            <el-option
                              v-for="item in monthOptions"
                              :key="item"
                              :label="item"
                              :value="item"
                            >
                            </el-option> </el-select
                          >日
                          <el-time-picker
                            v-model="props.row.monthTimeValue[0]"
                            :disabled="periodType != '1'"
                            class="time_picker_box"
                            format="HH:mm"
                            value-format="HH:mm"
                            arrow-control
                            size="small"
                            style="width:100px"
                          ></el-time-picker>
                          至
                          <el-time-picker
                            v-model="props.row.monthTimeValue[1]"
                            :disabled="periodType != '1'"
                            class="time_picker_box"
                            format="HH:mm"
                            value-format="HH:mm"
                            arrow-control
                            size="small"
                            style="width:100px"
                          ></el-time-picker>
                        </el-radio>
                        <el-radio label="2" class="dblock">
                          <span class="radio_name">每周</span>
                          <el-popover
                            placement="right"
                            width="100"
                            trigger="click"
                            v-model="props.row.showAddWeek">
                            <el-select v-model="props.row.selectWeekItem">
                              <el-option v-for="item in weekOptions" :key="item.value" :label="item.name" :value="item.value" :disabled="item.selected"></el-option>
                            </el-select>
                            <div style="margin-top:10px">
                              <el-button size="mini" @click="addWeekItem()">确定</el-button>
                              <el-button size="mini" @click="props.row.showAddWeek=false;props.row.selectWeekItem=''">取消</el-button>
                            </div>
                            <el-button slot="reference" type="text" size="medium" :disabled="props.row.periodType != '2'">添加星期</el-button>
                          </el-popover>
                          <div class="week_item" v-for="item in weekDayValue" :key="item.value">
                            <span>{{item.name}}</span>
                            <el-time-picker
                              v-model="item.stime"
                              :disabled="props.row.periodType != '2'"
                              class="time_picker_box"
                              format="HH:mm"
                              value-format="HH:mm"
                              arrow-control
                              size="small"
                              style="width:100px"
                            ></el-time-picker>
                            至
                            <el-time-picker
                              v-model="item.etime"
                              :disabled="props.row.periodType != '2'"
                              class="time_picker_box"
                              format="HH:mm"
                              value-format="HH:mm"
                              arrow-control
                              size="small"
                              style="width:100px"
                            ></el-time-picker>
                            <span>
                              <el-button type="danger" size="small" @click="delWeekItem(item.value)">删除</el-button>
                            </span>
                          </div>
                        </el-radio>
                      </el-radio-group>
                    </div>
                  </el-form-item>
                  <el-form-item label="优惠内容">
                    <!-- <el-input-number v-model="formData.discount" class="input_box_small" :controls="false"></el-input-number> -->
                    <el-radio-group v-model="props.row.discount_type" @change="changeDiscountType">
                      <el-radio :label="0">统一优惠</el-radio>
                      <el-radio :label="1">按类别优惠</el-radio>
                      <el-radio :label="2">按油品优惠</el-radio>
                    </el-radio-group>
                    <div v-if="discount_type == 0">
                      <el-radio-group v-model="unified_type">
                        <el-radio :label="0" class="dblock">
                          享受折扣
                          <el-input
                            v-model="unified_type_value.discount"
                            size="mini"
                            class="input_box_mini"
                            @focus="inputFocus(0, 0)"
                          >
                          </el-input>
                          折
                        </el-radio>
                        <el-radio :label="1" class="dblock">
                          每升优惠
                          <el-input
                            v-model="unified_type_value.money"
                            size="mini"
                            class="input_box_mini"
                            @focus="inputFocus(0, 1)"
                          >
                          </el-input>
                          元
                        </el-radio>
                      </el-radio-group>
                    </div>
                    <div v-if="discount_type == 1">
                      <div
                        class="type_item"
                        v-for="(item, index) in type_discount_list"
                        :key="index"
                      >
                        <div class="type_name">
                          <el-select
                            v-model="item.id"
                            @change="resetOptions(1)"
                            placeholder="选择类别"
                          >
                            <el-option
                              v-for="type in type_options"
                              :key="type.id"
                              :value="type.id"
                              :label="type.name"
                              :disabled="type.disable"
                            ></el-option>
                          </el-select>
                        </div>
                        <div class="type_value">
                          <el-radio-group v-model="item.type">
                            <el-radio :label="0" class="dblock">
                              享受折扣
                              <el-input
                                v-model="item.discount"
                                size="mini"
                                class="input_box_mini"
                                @focus="inputFocus(1, index, 0)"
                              >
                              </el-input>
                              折
                            </el-radio>
                            <el-radio :label="1" class="dblock">
                              每升优惠
                              <el-input
                                v-model="item.money"
                                size="mini"
                                class="input_box_mini"
                                @focus="inputFocus(1, index, 1)"
                              >
                              </el-input>
                              元
                            </el-radio>
                          </el-radio-group>
                        </div>
                        <div class="type_del">
                          <el-button
                            type="danger"
                            icon="el-icon-close"
                            size="mini"
                            @click="delTypeItem(index, 1)"
                          ></el-button>
                        </div>
                      </div>
                      <div class="add_button">
                        <el-button type="primary" size="small" @click="addTypeItem(1)"
                          >增加规则</el-button
                        >
                      </div>
                    </div>
                    <div v-if="discount_type == 2">
                      <div
                        class="type_item"
                        v-for="(item, index) in oils_discount_list"
                        :key="index"
                      >
                        <div class="type_name">
                          <el-select
                            v-model="item.id"
                            @change="resetOptions(2)"
                            placeholder="选择油品"
                          >
                            <el-option
                              v-for="type in oils_options"
                              :key="type.id"
                              :value="type.id"
                              :label="type.name"
                              :disabled="type.disable"
                            ></el-option>
                          </el-select>
                        </div>
                        <div class="type_value">
                          <el-radio-group v-model="item.type">
                            <el-radio :label="0" class="dblock">
                              享受折扣
                              <el-input
                                v-model="item.discount"
                                size="mini"
                                class="input_box_mini"
                                @focus="inputFocus(2, index, 0)"
                              >
                              </el-input>
                              折
                            </el-radio>
                            <el-radio :label="1" class="dblock">
                              每升优惠
                              <el-input
                                v-model="item.money"
                                size="mini"
                                class="input_box_mini"
                                @focus="inputFocus(2, index, 1)"
                              >
                              </el-input>
                              元
                            </el-radio>
                          </el-radio-group>
                        </div>
                        <div class="type_del">
                          <el-button
                            type="danger"
                            icon="el-icon-close"
                            size="mini"
                            @click="delTypeItem(index, 2)"
                          ></el-button>
                        </div>
                      </div>
                      <div class="add_button">
                        <el-button type="primary" size="small" @click="addTypeItem(2)"
                          >增加规则</el-button
                        >
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="赠送内容"></el-form-item>
                  <el-form-item label="升级条件"></el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column label="等级名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="级别" width="100px" prop="level"></el-table-column>
            <el-table-column label="等级优惠">
              <template slot-scope="scope">
                <div>{{scope.row.show_discount}}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120px">
              <template slot-scope="scope">
                <el-button type="text" @click="delItem(scope.$index)" size="medium">删除</el-button>
                <el-button type="text" @click="showItem(scope.row)" size="medium">详细设置</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px">
            <el-button size="small" type="primary" @click="addLevelItem()">添加等级</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="submit()" :loading="uploadLoading"
          >提交</el-button
        >
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showSelecter" @close="showSelecter = false">
      <newSelectCommodityNum
        @close="showSelecter = false"
        @getCommod="getCommod"
        :sList="sList"
        :jude="2"
      ></newSelectCommodityNum>
    </el-dialog>
  </div>
</template>
<script>
import newSelectCommodityNum from "@/components/commodity/newSelectCommodityNum.vue";
import { mapGetters } from "vuex";
import {
  addLevel,
  detailLevel,
  editLevel,
  getOilSortList,
  goodsOptions,
  vipList
} from "@/api/vip";
import { getPayWay } from "@/api/pointSetting";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  components: {
    newSelectCommodityNum
  },
  mounted() {
    this.init();
    this.monthOptions = new Array(31)
      .toString()
      .split(",")
      .map(function(item, index) {
        var realNum = index + 1;
        if (realNum < 10) {
          return "0" + realNum;
        } else {
          return realNum;
        }
      });
  },
  data() {
    return {
      formData: {},
      if_add: true, //是否是新添加
      loading: false, //页面loading
      uploadLoading: false, //上传时loading
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      discount_type: 0, //优惠内容 0:统一优惠 1:按类别 2:按油品
      type_options: [], //油品类别选项
      type_discount_list: [], //按类型优惠
      oils_options: [], //油品选项
      oils_discount_list: [], //按油品优惠
      unified_type: 0, //统一优惠方式 0:折扣 1:每升减价
      unified_type_value: {
        //统一优惠方式
        type: 0,
        discount: "",
        money: ""
      },
      listLength: 0, //已有会员卡列表
      timeType: 0, //有效时间类型 0:长期有效 1:固定时间段 2:按周期重复
      dateValue: [], //固定时间段
      periodType: "0", //按周期你
      dayTimeValue: ["00:00", "23:59"], //每天重复
      monthDayValue: [], //每月重复 日
      monthTimeValue: ["00:00", "23:59"], //每月重复 时间
      monthOptions: [], //每月重复 日 选择项
      weekDayValue: [], //每周重复 日
      weekTimeValue: ["00:00", "23:59"], //每周重复 时间
      weekOptions: [
        { value: "1", name: "周一" },
        { value: "2", name: "周二" },
        { value: "3", name: "周三" },
        { value: "4", name: "周四" },
        { value: "5", name: "周五" },
        { value: "6", name: "周六" },
        { value: "7", name: "周日" }
      ], //每周重复 选择项
      checkList: [], //适用场景
      checkList_option: [], //使用场景选项
      levelSet: [
        {name: '普通会员',level: 1}
      ], // 改版 等级列表
    };
  },
  methods: {
    init() {
      this.formData = {
        is_forever: 1,
        is_pay: 1,
        is_show: 1,
        is_default: 0
      };
      this.$nextTick(() => {
        // 判断是否是第一张会员卡
        vipList({ token: this.token, app_id: this.app_id }).then(res => {
          if (res.code == 200 || res.code == 400) {
            this.listLength = res.data.length;
            console.log(this.listLength);
            if (this.listLength == 0) {
              this.formData.is_default = 1;
            }
          }
        });
      });
      //判断是否是编辑会员卡
      if (this.$route.query.vid) {
        this.loading = true;
        this.if_add = false;
        var data = {
          token: this.token,
          app_id: this.app_id,
          id: this.$route.query.vid
        };
        detailLevel(data).then(res => {
          console.log("表单详情", res);
          if (res.code == 200) {
            this.formData = Object.assign({}, res.data);

            let arrIds = this.formData.coupon_ids.split(",");
            let coupons = res.data.coupon;

            for (let i = 0; i < coupons.length; i++) {
              console.log("coupons", i);
              let choseNum = "0";
              for (let j = 0; j < arrIds.length; j++) {
                if (coupons[i].id == arrIds[j]) {
                  choseNum++;
                }
              }
              var obj = {};
              obj.choseNum = choseNum;
              obj.id = coupons[i].id;
              obj.name = coupons[i].title;
              obj.url =
                "https://zltc-1255680458.cos.ap-beijing.myqcloud.com/1576482532.jpg";
              this.sList.push(obj);
            }
            console.log("this.sList", this.sList);
            this.formData.is_coupon = this.formData.is_coupon ? true : false;
            this.formData.is_points = this.formData.is_points ? true : false;
            this.formData.is_grow_points = this.formData.is_grow_points
              ? true
              : false;
            this.formData.is_balance = this.formData.is_balance ? true : false;
            // this.formData.discount = this.formData.discount / 10;
            if (this.formData.unified_offer == "1") {
              this.discount_type = 0;
              this.unified_type =
                this.formData.unified_offer_value.money_status == "1" ? 1 : 0;
              this.unified_type_value = {
                discount:
                  Number(this.formData.unified_offer_value.discount) / 10,
                money: this.formData.unified_offer_value.money
              };
            } else if (this.formData.cate_offer == "1") {
              this.discount_type = 1;
              this.type_discount_list = [];
              this.formData.cate_offer_value.forEach(item => {
                var i = {
                  id: item.cate,
                  type: item.discount_status == "1" ? 0 : 1,
                  discount: Number(item.discount) / 10 || "",
                  money: item.money
                };
                this.type_discount_list.push(i);
              });
            } else if (this.formData.goods_offer == "1") {
              this.discount_type = 2;
              this.oils_discount_list = [];
              this.formData.goods_offer_value.forEach(item => {
                var i = {
                  id: item.goods,
                  type: item.discount_status == "1" ? 0 : 1,
                  discount: Number(item.discount) / 10 || "",
                  money: item.money
                };
                this.oils_discount_list.push(i);
              });
            }
            /**
             * 新增优惠时间处理
             */
            this.timeType = res.data.time_status;
            if (res.data.time_status == 1) {
              this.dateValue = [res.data.start_time, res.data.end_time];
            } else {
              if (res.data.day_status == 1) {
                this.periodType = "0";
                this.dayTimeValue = [
                  res.data.day_value.start_time,
                  res.data.day_value.end_time
                ];
              } else if (res.data.month_status == 1) {
                this.periodType = "1";
                this.monthDayValue = res.data.month_value.number.split(",");
                this.monthTimeValue = [
                  res.data.month_value.start_time,
                  res.data.month_value.end_time
                ];
              } else if (res.data.week_status == 1) {
                this.periodType = "2";
                var week = res.data.week_value.week;
                if (week.Mon == "1") {
                  var timeData = res.data.week_value.time.Mon.split(',');
                  var itemData = {
                    value: "1",
                    name: "周一",
                    stime: timeData[0],
                    etime: timeData[1]
                  }
                  this.weekDayValue.push(itemData);
                }
                if (week.Tue == "1") {
                  var timeData = res.data.week_value.time.Tue.split(',');
                  var itemData = {
                    value: "2",
                    name: "周二",
                    stime: timeData[0],
                    etime: timeData[1]
                  }
                  this.weekDayValue.push(itemData);
                }
                if (week.Wed == "1") {
                  var timeData = res.data.week_value.time.Wed.split(',');
                  var itemData = {
                    value: "3",
                    name: "周三",
                    stime: timeData[0],
                    etime: timeData[1]
                  }
                  this.weekDayValue.push(itemData);
                }
                if (week.Thur == "1") {
                  var timeData = res.data.week_value.time.Thur.split(',');
                  var itemData = {
                    value: "4",
                    name: "周四",
                    stime: timeData[0],
                    etime: timeData[1]
                  }
                  this.weekDayValue.push(itemData);
                }
                if (week.Fri == "1") {
                  var timeData = res.data.week_value.time.Fri.split(',');
                  var itemData = {
                    value: "5",
                    name: "周五",
                    stime: timeData[0],
                    etime: timeData[1]
                  }
                  this.weekDayValue.push(itemData);
                }
                if (week.Sat == "1") {
                  var timeData = res.data.week_value.time.Sat.split(',');
                  var itemData = {
                    value: "6",
                    name: "周六",
                    stime: timeData[0],
                    etime: timeData[1]
                  }
                  this.weekDayValue.push(itemData);
                }
                if (week.Sun == "1") {
                  var timeData = res.data.week_value.time.Sun.split(',');
                  var itemData = {
                    value: "7",
                    name: "周日",
                    stime: timeData[0],
                    etime: timeData[1]
                  }
                  this.weekDayValue.push(itemData);
                }
              }
            }
            delete this.formData.create_time;
            delete this.formData.is_del;
            delete this.formData.image_url;
            delete this.formData.icon_url;
          }
          this.loading = false;
          this.weekDayValue.forEach(item => {
            var idx = this.weekOptions.findIndex(x => x.value == item.value);
            if(idx != -1){
              this.weekOptions[idx].selected = true;
            }
          })
        });
      }
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除选择的优惠券
    delTagItem(i) {
      console.log(i);
      this.sList.splice(i, 1);
    },
    closeDialog() {
      this.showAdd = false;
    },
    submit() {
      this.save();
    },
    // 图片上传
    // 上传之前1
    upBefore(file) {
      console.log(file);
      this.imgdata.image = file;
      this.imageUrl = URL.createObjectURL(file);
      console.log(this.imgdata);
      this.uploadLoading = true;
    },
    //上传成功1
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.image_id = res.data.id;
      this.uploadLoading = false;
    },
    // 上传之前2
    upBefore2(file) {
      console.log(file);
      this.imgdata2.image = file;
      this.imageUrl2 = URL.createObjectURL(file);
      console.log(this.imgdata2);
      this.uploadLoading = true;
    },
    //上传成功2
    handleAvatarSuccess2(res, file) {
      console.log(res);
      this.image_id2 = res.data.id;
      this.uploadLoading = false;
    },
    //保存表单
    save() {
      var data = Object.assign({}, this.formData);
      // data.icon = this.image_id; //图标
      // data.image = this.image_id2; //背景
      data.token = this.token;
      data.app_id = this.app_id;
      // 新增内容
      // var ids = [];
      let arrCountId = [];

      this.sList.forEach(item => {
        // if(item.choseNum)
        for (var n = 0; n < Number(item.choseNum); n++) {
          arrCountId.push(item.id);
        }
      });
      data.coupon_ids = arrCountId.join(",");
      data.is_coupon = data.is_coupon ? 1 : 0;
      data.is_points = data.is_points ? 1 : 0;
      data.is_grow_points = data.is_grow_points ? 1 : 0;
      data.is_balance = data.is_balance ? 1 : 0;
      data.unified_offer = "0";
      data.cate_offer = "0";
      data.goods_offer = "0";
      if (this.discount_type == 0) {
        data.unified_offer = "1";
        data.unified_offer_value = {
          discount_status: this.unified_type == 0 ? "1" : "0",
          discount:
            this.unified_type == 0
              ? Number(this.unified_type_value.discount) * 10 || "100"
              : "",
          money_status: this.unified_type == 1 ? "1" : "0",
          money: this.unified_type == 1 ? this.unified_type_value.money : ""
        };
      }
      if (this.discount_type == 1) {
        data.cate_offer = "1";
        data.cate_offer_value = [];
        this.type_discount_list.forEach(item => {
          var i = {
            cate: item.id,
            discount_status: item.type == 0 ? "1" : "0",
            discount: item.type == 0 ? Number(item.discount) * 10 || "100" : "",
            money_status: item.type == 1 ? "1" : "0",
            money: item.type == 1 ? item.money : ""
          };
          data.cate_offer_value.push(i);
        });
      }
      if (this.discount_type == 2) {
        data.goods_offer = "1";
        data.goods_offer_value = [];
        console.log(this.oils_discount_list);
        this.oils_discount_list.forEach(item => {
          var g = {
            goods: item.id,
            discount_status: item.type == 0 ? "1" : "0",
            discount: item.type == 0 ? Number(item.discount) * 10 || "100" : "",
            money_status: item.type == 1 ? "1" : "0",
            money: item.type == 1 ? item.money : ""
          };
          data.goods_offer_value.push(g);
        });
      }
      // if(data.discount == undefined || data.discount == ''){
      //   data.discount == 100;
      // }else{
      //   data.discount = Number(data.discount) * 10;
      // }
      // data.discount = Number(data.discount) * 10 || '100';
      /**
       * 新增优惠时间处理
       */
      data.time_status = this.timeType;
      data.day_status = 0;
      data.month_status = 0;
      data.week_status = 0;
      if (data.time_status == 1) {
        //固定时间段
        data.start_time = this.dateValue[0];
        data.end_time = this.dateValue[1];
      }
      if (data.time_status == 2) {
        //按周期重复
        if (this.periodType == "0") {
          data.day_status = 1;
          data.day_value = {
            start_time: this.dayTimeValue[0],
            end_time: this.dayTimeValue[1]
          };
        } else if (this.periodType == "1") {
          data.month_status = 1;
          data.month_value = {
            start_time: this.monthTimeValue[0],
            end_time: this.monthTimeValue[1],
            number: this.monthDayValue.join(",")
          };
        } else if (this.periodType == "2") {
          var timeData = {
            Mon: "",
            Tue: "",
            Wed: "",
            Thur: "",
            Fri: "",
            Sat: "",
            Sun: ""
          }
          this.weekDayValue.forEach( item => {
            if(item.value == '1'){
              timeData.Mon = item.stime + "," + item.etime;
            }else if(item.value == '2'){
              timeData.Tue = item.stime + "," + item.etime;
            }else if(item.value == '3'){
              timeData.Wed = item.stime + "," + item.etime;
            }else if(item.value == '4'){
              timeData.Thur = item.stime + "," + item.etime;
            }else if(item.value == '5'){
              timeData.Fri = item.stime + "," + item.etime;
            }else if(item.value == '6'){
              timeData.Sat = item.stime + "," + item.etime;
            }else if(item.value == '7'){
              timeData.Sun = item.stime + "," + item.etime;
            }
          })
          data.week_status = 1;
          data.week_value = {
            week: {
              Mon: this.weekDayValue.some(x => x.value == "1") ? "1" : "0",
              Tue: this.weekDayValue.some(x => x.value == "2") ? "1" : "0",
              Wed: this.weekDayValue.some(x => x.value == "3") ? "1" : "0",
              Thur: this.weekDayValue.some(x => x.value == "4") ? "1" : "0",
              Fri: this.weekDayValue.some(x => x.value == "5") ? "1" : "0",
              Sat: this.weekDayValue.some(x => x.value == "6") ? "1" : "0",
              Sun: this.weekDayValue.some(x => x.value == "7") ? "1" : "0"
            },
            time: timeData
          };
        }
      }
      console.log("表单上传数据", data);
      // return false;
      if (this.if_add) {
        if (this.listLength == 0 && data.is_default == 0) {
          this.$message("第一张会员卡必须设为默认！");
        } else {
          addLevel(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg
              });
              this.goback();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        }
      } else {
        editLevel(data).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.goback();
          } else {
            this.$message({
              type: "error",
              message: res.msg
            });
          }
        });
      }
    },
    goback() {
      this.$router.go(-1);
    },
    // 优惠内容类型
    changeDiscountType(val) {
      console.log(val);
      if (this.discount_type == 0) {
      }
      if (this.discount_type == 1) {
        this.type_discount_list = [
          { id: "", type: 0, discount: "", money: "" }
        ];
        this.resetOptions(1);
      }
      if (this.discount_type == 2) {
        this.oils_discount_list = [
          { id: "", type: 0, discount: "", money: "" }
        ];
        this.resetOptions(2);
      }
    },
    // 增加规则
    addTypeItem(i) {
      if (i == 1) {
        this.type_discount_list.push({
          id: "",
          type: 0,
          discount: "",
          money: ""
        });
      } else {
        this.oils_discount_list.push({
          id: "",
          type: 0,
          discount: "",
          money: ""
        });
      }
    },
    // 删除规则
    delTypeItem(index, i) {
      if (i == 1) {
        this.type_discount_list.splice(index, 1);
      } else {
        this.oils_discount_list.splice(index, 1);
      }
      this.resetOptions(i);
    },
    //防止重复选择内容 优惠内容 类别/油品
    resetOptions(i) {
      if (i == 1) {
        this.type_options.forEach(item => {
          item.disable = false;
        });
        this.type_discount_list.forEach(item => {
          this.type_options.forEach(options => {
            if (options.id == item.id) {
              options.disable = true;
            }
          });
        });
      } else {
        this.oils_options.forEach(item => {
          item.disable = false;
        });
        this.oils_discount_list.forEach(item => {
          this.oils_options.forEach(options => {
            if (options.id == item.id) {
              options.disable = true;
            }
          });
        });
      }
    },
    // 优惠内容 输入框获得焦点的时候选中该选项
    inputFocus(type, item, index) {
      console.log(type, item, index);
      if (type == 0) {
        this.unified_type = item;
      } else if (type == 1) {
        this.type_discount_list[item].type = index;
      } else if (type == 2) {
        this.oils_discount_list[item].type = index;
      }
    },
    // 添加星期
    addWeekItem(){
      var data = {
        value: this.selectWeekItem,
        stime: "",
        etime: ""
      }
      var wIndex = this.weekOptions.findIndex(x => x.value == data.value);
      data.name = this.weekOptions[wIndex].name;
      this.showAddWeek = false;
      this.weekOptions[wIndex].selected = true;
      this.weekDayValue.push(data);
      console.log(this.weekDayValue);
      this.selectWeekItem = "";
    },
    // 删除星期
    delWeekItem(id){
      this.weekDayValue.splice(this.weekDayValue.findIndex(x => x.value == id),1);
      var index = this.weekOptions.findIndex(x => x.value == id);
      this.weekOptions[index].selected = false;
    },
    // 表格展开行
    showItem(row){
      console.log(row)
      console.log(this.$refs.levelTable)
      this.$refs.levelTable.toggleRowExpansion(row)
    },
    // 添加级别
    addLevelItem(){
      if(this.levelSet.length < 5){
        var item = {
          name: ""
        }
        item.level = this.levelSet.length + 1;
        this.levelSet.push(item)
        var row = this.$refs.levelTable.data[this.$refs.levelTable.data.length-1]
        this.$refs.levelTable.toggleRowExpansion(row)
      }else{
        this.$message('最多添加5个级别')
      }
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.colorRed {
  color: red;
  padding: 0 6px;
}
.minWidth {
  min-width: 80px;
}
.buttonInput {
  width: 100px;
  padding: 0 10px;
  color: #409eff;
  height: 28px;
  line-height: 28px;
  border: 1px solid #409eff;
  border-radius: 5px;
  text-align: center;
}
.padding10 {
  padding: 0 10px;
  display: flex;
}
.margin10 {
  margin: 10px 0;
  display: flex;
}
.smallinput {
  width: 100px;
  padding: 0 10px;
}
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: auto;
    background: #fff;
    .input_box {
      width: 400px;
    }
    .input_box_small {
      width: 120px;
    }
    .input_box_mini {
      width: 60px;
    }
    .dblock {
      display: block;
      margin-top: 12px;
    }
    .type_item {
      display: flex;
      .type_name {
        padding-right: 10px;
        margin-top: 15px;
        margin-right: 10px;
        border-right: 1px solid #eee;
      }
      .type_del {
        margin-top: 10px;
      }
    }
    .add_button {
      margin-top: 15px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
    // 图片上传
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 80px;
      height: 80px;
      line-height: 80px;
      text-align: center;
    }
    .avatar {
      width: 80px;
      height: 80px;
      display: block;
    }
  }
  .day_time_box {
    width: 80px;
  }
  .radio_name {
    margin-right: 15px;
  }
  .week_select {
    display: inline-block;
    vertical-align: top;
    margin-right: 10px;
  }
  .week_item{
    margin-left: 57px;
    margin-top: 10px;
    line-height: 20px;
    color: #333;
    span{
      margin:0 10px;
    }
  }
}
</style>
